var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "fileListView" }, [
    ["xls", "xlsx", "cvs", "xlsm"].includes(_vm.imgType)
      ? _c("img", {
          staticClass: "size-icon",
          attrs: { src: require("@/assets/image/pdf.png"), fit: "contain" },
        })
      : ["ppt", "pptx"].includes(_vm.imgType)
      ? _c("img", {
          staticClass: "size-icon",
          attrs: { src: require("@/assets/image/ppt.png"), fit: "contain" },
        })
      : ["doc", "docx", "pdf"].includes(_vm.imgType)
      ? _c("img", {
          staticClass: "size-icon",
          attrs: { src: require("@/assets/image/ppt2.png"), fit: "contain" },
        })
      : ["word"].includes(_vm.imgType)
      ? _c("img", {
          staticClass: "size-icon",
          attrs: { src: require("@/assets/image/word.png"), fit: "contain" },
        })
      : ["txt"].includes(_vm.imgType)
      ? _c("img", {
          staticClass: "size-icon",
          attrs: { src: require("@/assets/image/txt.png"), fit: "contain" },
        })
      : _c("img", {
          staticClass: "size-icon",
          attrs: {
            src: require("@/assets/image/weizhigeshi.png"),
            fit: "contain",
          },
        }),
    _c(
      "div",
      { staticClass: "fileName" },
      [_c("textShowMore", { attrs: { "line-clamp": 1, text: _vm.fileName } })],
      1
    ),
    _c("div", { staticClass: "fileBtn" }, [
      _vm.status === 3
        ? _c(
            "div",
            {
              staticClass: "fileBtnIcon",
              on: {
                click: function ($event) {
                  return _vm.openFile()
                },
                mouseenter: function ($event) {
                  _vm.alignUploadShow = true
                },
                mouseleave: function ($event) {
                  _vm.alignUploadShow = false
                },
              },
            },
            [
              _vm.alignUploadShow
                ? _c("img", {
                    attrs: {
                      src: require("@/assets/image/aigc/filePreview_c.png"),
                    },
                  })
                : _c("img", {
                    attrs: {
                      src: require("@/assets/image/aigc/filePreview.png"),
                    },
                  }),
              _vm.alignUploadShow
                ? _c("div", { staticClass: "preview" }, [_vm._v("预览")])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "fileBtnIcon" }, [
        _vm.alignUploadShow2
          ? _c("div", { staticClass: "preview" }, [_vm._v("删除")])
          : _vm._e(),
        _c("img", {
          attrs: { src: require("@/assets/image/aigc/aiDel.png") },
          on: {
            click: function ($event) {
              return _vm.$emit("del")
            },
            mouseenter: function ($event) {
              _vm.alignUploadShow2 = true
            },
            mouseleave: function ($event) {
              _vm.alignUploadShow2 = false
            },
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }